/// <reference types="koa-body" />
import type formidable from 'formidable'
import type Koa from 'koa'
import type { FileId } from '../../../shared/domain/files'
import type { Nullable } from '../../../shared/lib/typeHelpers.no-deps'
import type { Endpoint, Route } from '../types.no-deps'

export const route: Route = { method: 'POST', pattern: '/api/users/updateProfileImage' }

type Params = never
// We are using multi-part form upload for this request, ie not JSON,
// so type-ir can't validate this.  Instead, we use helper functions (below)
// to genererate the Body and extract data from it.
type Body = unknown
type Query = never
type Output = { fileId: Nullable<FileId> }

export type UpsertProfileImageEndpoint = Endpoint<Params, Body, Query, Output>

export const upsertProfileImageRequest = <TArgs, TOut>(sendRequest: (route: Route, args: TArgs) => TOut, args: TArgs) =>
    sendRequest(route, args)

const profileImageFormItemName = 'userProfileImage'

/** Create the body of a request for sending an image blob to the `UpsertProfileImageEndpoint` endpoint */
export function createBody(image: Blob | null) {
    const formData = new FormData()
    formData.append(profileImageFormItemName, image)
    return formData
}

export function getImageFromRequest(request: Koa.Request): formidable.File {
    return request.files[profileImageFormItemName] as formidable.File
}
